/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProductSplitDefinitionRequest { 
    id?: number;
    inProductInfoId?: number;
    outProductInfoId?: number;
    splitQuantity?: number;
    shape?: string;
    inProductSize?: string;
}

